import { StorageService } from '../_services/storage.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/storage.service";
var JwtInterceptorService = /** @class */ (function () {
    function JwtInterceptorService(storage) {
        this.storage = storage;
    }
    JwtInterceptorService.prototype.intercept = function (request, next) {
        var jwt = this.storage.getItemPlain("access_token");
        if (jwt) {
            request = request.clone({
                setHeaders: {
                    Authorization: "Bearer " + jwt
                }
            });
        }
        return next.handle(request);
    };
    JwtInterceptorService.ngInjectableDef = i0.defineInjectable({ factory: function JwtInterceptorService_Factory() { return new JwtInterceptorService(i0.inject(i1.StorageService)); }, token: JwtInterceptorService, providedIn: "root" });
    return JwtInterceptorService;
}());
export { JwtInterceptorService };
